/**
 * 业务相关翻译
 * 包含原 VSCode 扩展中的业务翻译
 */
export default {
  // Dashboard 仪表盘
  'business.dashboard.title': '猎头工作台',
  'business.dashboard.subtitle': '集中掌握候选人、职位、客户与项目的实时进度。',
  'business.dashboard.totalTalents': '总人才数',
  'business.dashboard.activeJobs': '进行中职位',
  'business.dashboard.totalClients': '总客户数',
  'business.dashboard.activeProjects': '进行中项目',
  'business.dashboard.successRateTrend': '推荐成功率趋势',
  'business.dashboard.projectStatus': '项目状态分布',
  'business.dashboard.viewDetails': '查看详情',
  'business.dashboard.monthlyTarget': '月度目标进度',
  'business.dashboard.talentTarget': '人才推荐目标',
  'business.dashboard.projectTarget': '项目交付目标',
  'business.dashboard.revenueTarget': '营收目标',
  'business.dashboard.recentActivities': '最新动态',
  'business.dashboard.viewAll': '查看全部',
  'business.dashboard.activity': '动态类型',
  'business.dashboard.name': '名称',
  'business.dashboard.time': '时间',
  'business.dashboard.status': '状态',
  'business.dashboard.completed': '已完成',
  'business.dashboard.processing': '处理中',
  'business.dashboard.pending': '待处理',
  'business.dashboard.quickActions': '快捷操作',
  'business.dashboard.addTalent': '新增人才',
  'business.dashboard.createJob': '创建职位',
  'business.dashboard.addClient': '新增客户',
  'business.dashboard.createProject': '创建项目',
  'business.dashboard.loading': '仪表盘数据加载中...',
  'business.dashboard.error': '仪表盘数据加载失败',
  'business.dashboard.retry': '重试',
  'business.dashboard.error.network': '网络错误，请检查网络连接后重试。',
  'business.dashboard.error.server': '服务器错误，请稍后重试。',
  'business.dashboard.error.unauthorized': '认证失败，请检查登录状态。',
  'business.dashboard.noData': '暂无活动记录',
};
